import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  //base: '/baseweb-dev/',
  base: '/',
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    // 期望滚动到哪个位置
    return {
      x: 0,
      y: 0
    }
  },
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'home',
      component: resolve => require(['@/view/HomePage'], resolve),
      meta: {
        title: '首页',
        type: 'cn'
      }
    },
    {
      path: '/apartment',
      name: 'apartment',
      component: resolve => require(['@/view/Apartment'], resolve),
      meta: {
        title: '服务公寓',
        type: 'cn'
      }
    },
    {
      path: '/checkin',
      name: 'checkin',
      component: resolve => require(['@/view/Checkin'], resolve),
      meta: {
        title: '安心入住',
        type: 'cn'
      }
    },
    {
      path: '/apartment/apadetail',
      name: 'apadetail',
      component: resolve => require(['@/view/Apadetail'], resolve),
      meta: {
        title: '服务公寓详情',
        type: 'cn'
      }
    },
    {
      path: '/trend',
      name: 'trend',
      component: resolve => require(['@/view/Trend'], resolve),
      meta: {
        title: 'base动向',
        type: 'cn'
      }
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: resolve => require(['@/view/Aboutus'], resolve),
      meta: {
        title: '关于base',
        type: 'cn'
      }
    },
    {
      path: '/jobchance',
      name: 'jobchance',
      component: resolve => require(['@/view/Jobchance'], resolve),
      meta: {
        title: '招贤纳士',
        type: 'cn'
      }
    },
    {
      path: '/business',
      name: 'business',
      component: resolve => require(['@/view/Business'], resolve),
      meta: {
        title: '商务合作',
        type: 'cn'
      }
    },
    {
      path: '/esg',
      name: 'esg',
      component: resolve => require(['@/view/Esg'], resolve),
      meta: {
        title: 'ESG策略与实践',
        type: 'cn'
      }
    },
    {
      path: '/contactus',
      name: 'contactus',
      component: resolve => require(['@/view/Contactus'], resolve),
      meta: {
        title: '联系我们',
        type: 'cn'
      }
    },
    {
      path: '/en',
      name: 'homeen',
      component: resolve => require(['@/view/HomePageEn'], resolve),
      meta: {
        title: 'Home',
        type: 'en'
      }
    },
    {
      path: '/en/apartment',
      name: 'apartmenten',
      component: resolve => require(['@/view/ApartmentEn'], resolve),
      meta: {
        title: 'Serviced Apartments',
        type: 'en'
      }
    },
    {
      path: '/en/checkin',
      name: 'checkinen',
      component: resolve => require(['@/view/CheckinEn'], resolve),
      meta: {
        title: 'Services',
        type: 'en'
      }
    },
    {
      path: '/en/apartment/apadetail',
      name: 'apadetailen',
      component: resolve => require(['@/view/ApadetailEn'], resolve),
      meta: {
        title: 'Serviced Apartments Detail',
        type: 'en'
      }
    },
    {
      path: '/en/trend',
      name: 'trenden',
      component: resolve => require(['@/view/TrendEn'], resolve),
      meta: {
        title: 'News',
        type: 'en'
      }
    },
    {
      path: '/en/aboutus',
      name: 'aboutusen',
      component: resolve => require(['@/view/AboutusEn'], resolve),
      meta: {
        title: 'About Us',
        type: 'en'
      }
    },
    {
      path: '/en/jobchance',
      name: 'jobchanceen',
      component: resolve => require(['@/view/JobchanceEn'], resolve),
      meta: {
        title: 'Join Us',
        type: 'en'
      }
    },
    {
      path: '/en/business',
      name: 'businessen',
      component: resolve => require(['@/view/BusinessEn'], resolve),
      meta: {
        title: 'Business',
        type: 'en'
      }
    },
    {
      path: '/en/esg',
      name: 'esgen',
      component: resolve => require(['@/view/EsgEn'], resolve),
      meta: {
        title: 'ESG Strategy & Practice',
        type: 'en'
      }
    },
    {
      path: '/en/contactus',
      name: 'contactusen',
      component: resolve => require(['@/view/ContactusEn'], resolve),
      meta: {
        title: 'Contact Us',
        type: 'en'
      }
    },
    {
      path: '/jp',
      name: 'homejp',
      component: resolve => require(['@/view/HomePageJp'], resolve),
      meta: {
        title: 'Home',
        type: 'jp'
      }
    },
    {
      path: '/jp/apartment',
      name: 'apartmentjp',
      component: resolve => require(['@/view/ApartmentJp'], resolve),
      meta: {
        title: 'サービスアパートメント',
        type: 'jp'
      }
    },
    {
      path: '/jp/checkin',
      name: 'checkinjp',
      component: resolve => require(['@/view/CheckinJp'], resolve),
      meta: {
        title: '安心入居',
        type: 'jp'
      }
    },
    {
      path: '/jp/apartment/apadetail',
      name: 'apadetailjp',
      component: resolve => require(['@/view/ApadetailJp'], resolve),
      meta: {
        title: 'サービスアパートメント',
        type: 'jp'
      }
    },
    {
      path: '/jp/trend',
      name: 'trendjp',
      component: resolve => require(['@/view/TrendJp'], resolve),
      meta: {
        title: 'baseニュース',
        type: 'jp'
      }
    },
    {
      path: '/jp/aboutus',
      name: 'aboutusjp',
      component: resolve => require(['@/view/AboutusJp'], resolve),
      meta: {
        title: 'baseについて',
        type: 'jp'
      }
    },
    {
      path: '/jp/jobchance',
      name: 'jobchancejp',
      component: resolve => require(['@/view/JobchanceJp'], resolve),
      meta: {
        title: '採用情報',
        type: 'jp'
      }
    },
    {
      path: '/jp/business',
      name: 'businessjp',
      component: resolve => require(['@/view/BusinessJp'], resolve),
      meta: {
        title: '業務提携',
        type: 'jp'
      }
    },
    {
      path: '/jp/esg',
      name: 'esgjp',
      component: resolve => require(['@/view/EsgJp'], resolve),
      meta: {
        title: 'ESG対策と実践',
        type: 'jp'
      }
    },
    {
      path: '/jp/contactus',
      name: 'contactusjp',
      component: resolve => require(['@/view/ContactusJp'], resolve),
      meta: {
        title: 'お問い合わせ',
        type: 'jp'
      }
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js